/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CarveOutListResponse } from './CarveOutListResponse';
import {
    CarveOutListResponseFromJSON,
    CarveOutListResponseFromJSONTyped,
    CarveOutListResponseToJSON,
} from './CarveOutListResponse';

/**
 * 
 * @export
 * @interface FindAllCarveOuts200Response
 */
export interface FindAllCarveOuts200Response {
    /**
     * 
     * @type {CarveOutListResponse}
     * @memberof FindAllCarveOuts200Response
     */
    data?: CarveOutListResponse;
}

/**
 * Check if a given object implements the FindAllCarveOuts200Response interface.
 */
export function instanceOfFindAllCarveOuts200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllCarveOuts200ResponseFromJSON(json: any): FindAllCarveOuts200Response {
    return FindAllCarveOuts200ResponseFromJSONTyped(json, false);
}

export function FindAllCarveOuts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllCarveOuts200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CarveOutListResponseFromJSON(json['data']),
    };
}

export function FindAllCarveOuts200ResponseToJSON(value?: FindAllCarveOuts200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CarveOutListResponseToJSON(value.data),
    };
}

